document.querySelectorAll('.sensor-explorer').forEach(explorer => {
  const details = [...explorer.querySelectorAll('.sensor-details details')];
  const buttons = [...explorer.querySelectorAll('[data-sensor]')];
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  svg.classList.add('sensor-connector');
  svg.setAttribute('aria-hidden', 'true');
  const path = document.createElementNS(ns, 'path');
  svg.appendChild(path);
  explorer.appendChild(svg);
  let selected = details.find(detail => detail.open)?.id || null;
  let frame = 0;
  function draw() {
    frame = 0;
    const detail = details.find(item => item.id === selected && item.open);
    const button = detail && buttons.find(item => 'sensor-' + item.dataset.sensor === selected);
    svg.hidden = !button;
    if (!button) return;
    const base = explorer.getBoundingClientRect();
    const point = button.getBoundingClientRect();
    const heading = detail.querySelector('summary').getBoundingClientRect();
    svg.setAttribute('viewBox', `0 0 ${base.width} ${base.height}`);
    const y = point.top + point.height / 2 - base.top;
    const endY = heading.top + heading.height / 2 - base.top;
    const endX = heading.left - base.left - 7;
    if (matchMedia('(max-width: 760px)').matches) {
      const startX = point.left - base.left;
      const rail = 2;
      path.setAttribute('d', `M ${startX} ${y} H ${rail} V ${endY} H ${Math.max(rail, endX)}`);
    } else {
      const startX = point.right - base.left;
      const image = explorer.querySelector('.sensor-figure').getBoundingClientRect();
      const rail = (image.right + heading.left) / 2 - base.left;
      path.setAttribute('d', `M ${startX} ${y} H ${rail} V ${endY} H ${endX}`);
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(draw); }
  function sync() {
    buttons.forEach(button => {
      const active = 'sensor-' + button.dataset.sensor === selected && document.getElementById(selected)?.open;
      button.setAttribute('aria-expanded', String(document.getElementById('sensor-' + button.dataset.sensor).open));
      button.classList.toggle('active', Boolean(active));
    });
    schedule();
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    selected = 'sensor-' + button.dataset.sensor;
    details.forEach(detail => { detail.open = detail.id === selected; });
    const detail = document.getElementById(selected);
    detail.querySelector('summary').focus({preventScroll:true});
    sync();
    if (matchMedia('(max-width: 760px)').matches) detail.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'nearest'});
  }));
  details.forEach(detail => {
    detail.querySelector('summary').addEventListener('click', () => {
      selected = detail.open ? null : detail.id;
      if (selected) details.forEach(other => { if (other !== detail) other.open = false; });
      schedule();
    });
    detail.addEventListener('toggle', sync);
  });
  new ResizeObserver(schedule).observe(explorer);
  explorer.querySelectorAll('img').forEach(img => img.addEventListener('load', schedule));
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('scroll', schedule, {passive:true});
  document.fonts?.ready.then(schedule);
  sync();
});
